import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Hero from "./components/Hero";
import WhatToExpect from "./components/WhatToExpect";
import Gallery from "./components/Gallery";
import EventDetails from "./components/EventDetails";
import ValueSection from "./components/ValueSection";
import Commitment from "./components/Commitment";
import SiteFooter from "./components/SiteFooter";
import StickyMobileCTA from "./components/StickyMobileCTA";
import VerifyEmailPage from "./components/VerifyEmailPage";
import MusicPlayer from "./components/MusicPlayer";
import Navbar from "./components/Navbar";

function Landing() {
    const [attendeeRefreshKey, setAttendeeRefreshKey] = useState(0);
    const [showModal, setShowModal] = useState(false);

    const handleSignupSuccess = () => {
        // Trigger live attendee strip refresh
        setAttendeeRefreshKey((k) => k + 1);
    };

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);

    return (
        <div className="bg-[#FAF9F6] text-slate-900 min-h-screen">
            <Navbar />
            <div id="home">
                <Hero
                    onSuccess={handleSignupSuccess}
                    attendeeRefreshKey={attendeeRefreshKey}
                    showModal={showModal}
                    openModal={openModal}
                    closeModal={closeModal}
                />
            </div>
            <WhatToExpect />
            <div className="w-full overflow-hidden py-10">
                <img
                    src="https://res.cloudinary.com/dyssxsxce/image/upload/q_auto/f_auto/v1777418543/panoramic-ais-fest_k9e04e.jpg"
                    alt="AIS Festival Panorama"
                    className="w-full h-auto object-cover max-h-[600px] shadow-2xl"
                />
            </div>
            <Gallery />
            <EventDetails />
            <ValueSection />
            <Commitment />
            <SiteFooter />
            <StickyMobileCTA onClick={openModal} />
        </div>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/verify" element={<VerifyEmailPage />} />
                <Route path="/verified" element={<VerifyEmailPage />} />
            </Routes>
            <MusicPlayer />
            <Toaster position="top-center" richColors />
        </BrowserRouter>
    );
}
